<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>{{ sysText.editActionItemCheckedOn_title }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-date-field
      [control]="this.form.controls.date"
      [icon]="'today'"
      [label]="sysText.dateCompleted">
    </app-date-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close(false)">
      {{ sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{ sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

